import api from '@/services/api'

const RESOURCE_URI = '/customer'

const fetchCustomerByDocument = (document) =>
  api.get(`${RESOURCE_URI}/${document}`)

const fetchCustomerReportsByCustomerId = (customerId) =>
  api.post(`${RESOURCE_URI}/report/by-customer`, { customerId })

const createCustomerReport = ({ storeId, customerId, reason }) =>
  api.post(`${RESOURCE_URI}/createreport`, { storeId, customerId, reason })

const deleteCustomerReport = (id) => api.delete(`${RESOURCE_URI}/report/${id}`)

const adjustCustomerPoints = ({ customerId, storeId, delta, reason }) =>
  api.post(`${RESOURCE_URI}/${customerId}/points/adjustments`, {
    storeId,
    delta,
    reason
  })

const fetchCustomerPointAdjustments = ({
  customerId,
  storeId,
  page = 1,
  limit = 20
}) =>
  api.get(`${RESOURCE_URI}/${customerId}/points/adjustments`, {
    params: { storeId, page, limit }
  })

export default {
  fetchCustomerByDocument,
  fetchCustomerReportsByCustomerId,
  createCustomerReport,
  deleteCustomerReport,
  adjustCustomerPoints,
  fetchCustomerPointAdjustments
}
